import React from 'react';
import { useTranslation } from '@hooks/useTranslation';

const ResourceInfo = ({ resource, context = 'borrowing' }) => {
    const { t } = useTranslation();

    if (!resource) {
        return null;
    }

    const labelKey = context === 'reservation' ? 'reservation.resource' : 'borrowing.resource';

    return (
        <div className="resource-info">
            <h4>{resource.name}</h4>
            <p>{resource.description}</p>
        </div>
    );
};

export default ResourceInfo;
